import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  selectDoesUserHaveRbacPermission,
  selectIsProductRecommendationsFeatureFlagOn,
  selectUuidProjectType,
  selectIsUuidBasedProject,
  selectIsAllCombinatorSearchQueryFeatureFlagOn,
} from 'core/userContext/selectors';
import { UuidProjectType } from 'core/userContext';
import noop from 'utils/noop';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { getQueryParam } from 'utils/query';
import { NEW_COLLECTION_ID } from 'modules/catalog/catalogConstants';
import { fetchCatalogNames } from 'modules/catalog/actions';
import { openHandlebarsModal } from 'modules/catalog/collections/actions';
import {
  selectCatalogFieldTypes,
  selectDefinedFieldTypes,
} from 'modules/catalogFieldTypes/selectors';
import {
  selectCatalogsAsDropdownOptions,
  getCatalogIsSubmitting,
} from 'modules/catalogTable/selectors';
import {
  updateFieldsForProperty,
  validateQuery,
} from 'modules/queryBuilder/legacyQueryBuilder/actions';
import {
  selectHasDynamicFields,
  selectOrderByDynamicLocation,
  selectUsesSmartRecos,
} from 'modules/queryBuilder/legacyQueryBuilder/selectors';
import CollectionBuilder from './CollectionBuilder';
import {
  changeCatalog,
  changeCollectionDescription,
  changeCollectionName,
  createCollection,
  changeCurrentFields,
  fetchCollection,
  updateCollection,
  previewCollection,
  resetCollectionBuilder,
} from '../actions';
import {
  selectCatalog,
  selectCurrentFields,
  selectDescription,
  selectDidPreviewData,
  selectError,
  selectId,
  selectIsFetchingCollection,
  selectIsLoadingPreview,
  selectIsSaving,
  selectName,
  selectPreviewData,
  selectCollectionHasChanged,
  selectCollectionNotFound,
} from '../selectors';

export class CollectionBuilderContainer extends React.Component {
  static defaultProps = {
    changeCatalog: noop,
    fetchCatalogs: noop,
    fetchCollection: noop,
    resetCollectionBuilder: noop,
  };

  /**
   * componentDidMount
   * Fetches the list of catalogs and the search query on mount.
   * @returns { void }
   */
  componentDidMount = () => {
    const { catalog, fetchCatalogs: fetchAllCatalogs } = this.props;
    const collectionId = getQueryParam(this.props, 'collectionId', NEW_COLLECTION_ID);

    fetchAllCatalogs();
    if (collectionId !== NEW_COLLECTION_ID) {
      this.props.fetchCollection(collectionId);
    } else if (catalog) {
      this.props.changeCatalog(catalog, true);
    }
  };

  /**
   * componentWillUnmount
   * Resets the collection builder state on unmount.
   * @returns { void }
   */
  componentWillUnmount = () => {
    this.props.resetCollectionBuilder();
  };

  render() {
    return <CollectionBuilder {...this.props} />;
  }
}

export const mapStateToProps = (state) => ({
  canManageCatalogs: selectDoesUserHaveRbacPermission(state)(PROJECT_PERMISSIONS.ManageCatalogs),
  canManageUserProfiles: selectDoesUserHaveRbacPermission(state)(
    PROJECT_PERMISSIONS.ManageUserProfiles,
  ),
  canViewAndExportUserData: selectDoesUserHaveRbacPermission(state)(
    PROJECT_PERMISSIONS.ViewAndExportUserData,
  ),
  catalog: selectCatalog(state),
  catalogs: selectCatalogsAsDropdownOptions(state),
  catalogFields: selectDefinedFieldTypes(state, selectCatalog(state)),
  catalogFieldTypes: selectCatalogFieldTypes(state, selectCatalog(state)),
  collectionHasChanged: selectCollectionHasChanged(state),
  collectionNotFound: selectCollectionNotFound(state),
  currentFields: selectCurrentFields(state),
  description: selectDescription(state),
  didPreviewData: selectDidPreviewData(state),
  error: selectError(state),
  hasDynamicFields: selectHasDynamicFields(state),
  id: selectId(state),
  isFetchingCollection: selectIsFetchingCollection(state),
  isFetchingCatalogs: getCatalogIsSubmitting(state),
  isLoadingPreview: selectIsLoadingPreview(state),
  isProductRecommendationsOn: selectIsProductRecommendationsFeatureFlagOn(state),
  isAllCombinatorSearchQueryOn: selectIsAllCombinatorSearchQueryFeatureFlagOn(state),
  isSaving: selectIsSaving(state),
  name: selectName(state),
  orderByDynamicLocation: selectOrderByDynamicLocation(state),
  previewData: selectPreviewData(state),
  usesSmartRecos: selectUsesSmartRecos(state),
  uuidProjectType: selectUuidProjectType(state) || UuidProjectType.EmailUnique,
  isUuidBased: selectIsUuidBasedProject(state),
});

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeCatalog,
      changeCollectionDescription,
      changeCollectionName,
      changeCurrentFields,
      createCollection,
      fetchCatalogs: fetchCatalogNames,
      fetchCollection,
      updateFieldsForProperty,
      updateCollection,
      openHandlebarsModal,
      previewCollection,
      validateQuery,
      resetCollectionBuilder,
    },
    dispatch,
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionBuilderContainer));
